import wildberriesIcon from 'assets/channels/wildberries.svg';
import ozonIcon from 'assets/channels/ozon.svg';
import wildberriesCircleIcon from 'assets/channels/wildberries-circle.svg';
import ozonCircleIcon from 'assets/channels/ozon-circle.svg';
import {formsDefaultData} from 'utils/seller/autostrategy/formsData';
import {OZON_ENTITIES} from 'utils/seller/campaigns/sellerOzonEntities';

const OZON_CABINET_URL = 'https://seller.ozon.ru/app/dashboard/main';
const WILDBERRIES_CABINET_URL = 'https://seller.wildberries.ru';

const VIDEO_TUTOR_DATA = {
  WB: {
    video: 'https://img.mymarilyn.ru/i/mfs-add-shop-video-tutor/wb/video.mp4',
    preview: 'https://img.mymarilyn.ru/i/mfs-add-shop-video-tutor/wb/preview.png'
  },
  OZON: {
    video: 'https://img.mymarilyn.ru/i/mfs-add-shop-video-tutor/ozon/video.mp4',
    preview: 'https://img.mymarilyn.ru/i/mfs-add-shop-video-tutor/ozon/preview.png'
  }
};

export const getSellerConnectionData = () => [
  {
    id: 'ozon',
    channelId: 21,
    display_name: 'Ozon',
    icon: ozonIcon,
    circleIcon: ozonCircleIcon,
    videoTutor: VIDEO_TUTOR_DATA.OZON,
    cabinetUrl: OZON_CABINET_URL,
    errorData: {
      title: 'Проверьте API-ключ',
      text: 'Убедитесь, что верно скопировали <a href="https://seller.ozon.ru/app/settings/performance-api" target="_blank">Client ID и Client Secret</a>'
    },
    descriptionList: ['<span>Зайдите в Ozon Seller, в раздел</span>&nbsp;<a target="_blank" class="m-link" href="https://seller.ozon.ru/app/settings/performance-api">Настройки → Performance API</a><span>, создайте новый аккаунт и&nbsp;добавьте в&nbsp;нём ключ. Скопируйте Client ID и Client Secret ключа.</span>'],
    formData: [
      {
        id: 'login',
        label: 'Client ID',
        required: 'Укажите Client ID'
      },
      {
        id: 'token',
        label: 'Client Secret',
        required: 'Укажите Client Secret'
      },
      {
        id: 'name',
        label: 'Название магазина',
        required: 'Укажите название магазина'
      }
    ]
  },
  {
    id: 'wildberries',
    channelId: 23,
    display_name: 'Wildberries',
    icon: wildberriesIcon,
    circleIcon: wildberriesCircleIcon,
    cabinetUrl: WILDBERRIES_CABINET_URL,
    videoTutor: VIDEO_TUTOR_DATA.WB,
    errorData: {
      title: 'Проверьте токен',
      text: 'Убедитесь, что <a href="https://seller.wildberries.ru/api-integrations" target="_blank">разрешили доступ</a> к категориям API «Продвижение», «Аналитика» и убрали галочки «Только на чтение», «Тестовый контур».'
    },
    descriptionList: [
      '<a target="_blank" class="m-link" href="https://seller.wildberries.ru/api-integrations">В личном кабинете селлера Wildberries</a> <span> создайте новый токен.</span>',
      'При создании переключитесь на&nbsp;вкладку «Для&nbsp;интеграции вручную», выберите «Базовый&nbsp;токен». Укажите название, отметьте категории «Аналитика», «Продвижение» и&nbsp;настройте уровень доступа — «Чтение и&nbsp;запись». '
    ],
    formData: [
      {
        id: 'token',
        label: 'Токен',
        required: 'Укажите токен'
      },
      {
        id: 'name',
        label: 'Название магазина',
        required: 'Укажите название магазина'
      }
    ]
  }
];

export const getConnectionById = (findId) => {
  const connectionList = getSellerConnectionData();
  return connectionList?.find(connection => connection.channelId === findId);
};

export const getErrorDataByConnectionId = (findId) => {
  const currentConnection = getConnectionById(findId);
  return currentConnection.errorData;
};

export const getIconConnectionById = (findId) => {
  const currentConnection = getConnectionById(findId);
  return currentConnection?.icon || null;
};

export const getUrlMarketplaceMainCabinetById = (findId) => {
  const currentConnection = getConnectionById(findId);
  return currentConnection?.cabinetUrl || null;
};

export const getConnectionByName = (findName) => {
  const connectionList = getSellerConnectionData();
  return connectionList?.find(connection => connection.id === findName);
};

export const getConnectionChannelIdByName = (findName) => {
  const connectionList = getSellerConnectionData();
  return connectionList?.find(connection => connection.id === findName)?.channelId;
};

export const getChannelIdByStrategyId = (strategyId) => {
  const formsData = formsDefaultData();

  const channelData = Object.entries(formsData).
    find(channelStrategyData => {
      const strategyKeyValue = channelStrategyData[1];
      const strategyList = Object.keys(strategyKeyValue);
      return strategyList.includes(strategyId);
    });

  return channelData?.[0] || null;
};

class SellerConnectionDataService {
  connectionList = [];

  constructor () {
    this.connectionList = getSellerConnectionData() || [];
  }

  isOzon (channelId) {
    return this.connectionList?.find(connection => connection.channelId === channelId)?.id === 'ozon';
  }

  isWb (channelId) {
    return this.connectionList?.find(connection => connection.channelId === channelId)?.id === 'wildberries';
  }

  isOzonPlacementTypeNotAllowed (type) {
    return OZON_ENTITIES.PLACEMENT_TYPES.NOT_ALLOWED.includes(type);
  }

  isOzonStrategyNotAllowed (placementType, strategyType) {
    return OZON_ENTITIES.STRATEGIES.ALLOWED.includes(strategyType) &&
          placementType === 'OZON_PAY_PER_CLICK';
  }
}

export const sellerConnectionDataService = new SellerConnectionDataService();

